export default __webpack_public_path__ + "static/iphone-blue@2x-141ee3080a8e6c25d850b877011f720e.png";